import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

import { applicationService } from 'services/application';
import { resolveFromToken } from 'utils/resolveFromToken';

import * as config from './application.json';

Sentry.init({
  dsn:
    'https://12f0f41550d44f2485ee1afcf657d203@o457708.ingest.sentry.io/4503976636645376',
  integrations: [new BrowserTracing()],
  tracesSampleRate: 0.05,
  environment: 'production',
  enabled: config.ENV === 'production',
  sampleRate: 1,
});

Sentry.setUser({
  id: resolveFromToken('userId') as string,
  applicationId: applicationService.getApplicationId(),
});

Sentry.setTag('app_version', applicationService.getAppVersion());
